import script from "./HuShiChildDepart.vue?vue&type=script&setup=true&lang=js"
export * from "./HuShiChildDepart.vue?vue&type=script&setup=true&lang=js"

import "./HuShiChildDepart.vue?vue&type=style&index=0&id=137849a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137849a0"]])

export default __exports__